<template>
  <div class="authority-manage account-manage position-header">
    <div class="top-title">
      <navHeader :titleList="['系统管理', '用户管理']" />
    </div>
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row :gutter="14">
          <el-col :span="4">
            <el-input v-model="account" placeholder="请输入姓名" size="small"></el-input>
          </el-col>
          <el-col :span="20">
            <el-button @click="search" class="btn-search" round icon="el-icon-search" size="small">查询</el-button>
            <el-button @click="reset" type="warning" round icon="el-icon-refresh" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-button icon="el-icon-plus" class="btns-add" size="small" @click="addAccount">添加</el-button>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table :data="tableData" border style="width: 100%" class="flex-1" stripe height="100%">
            <el-table-column
              label="序号"
              width="60"
              align="center"
              type="index"
            ></el-table-column>
            <el-table-column
              prop="username"
              label="登录账号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="operate-btns">

                  <div class="btn-box">
                    <el-switch
                      v-model="scope.row.lockFlag"
                      active-value="2"
                      inactive-value="1"
                      active-text="锁定"
                      inactive-text="正常"
                      active-color="#ff4949"
                      inactive-color="#13ce66"
                      @change="isLock(scope.row.id, scope.row.lockFlag)"
                    >
                    </el-switch>
                    <el-button @click="edit(scope.row.id)" icon="el-icon-edit" type="text" size="medium">编辑</el-button>
                    <el-button @click="assignRoles(scope.row.id)" icon="el-icon-thumb" type="text" size="medium">分配角色</el-button>
                    <el-button @click="resetPassword(scope.row.id)" icon="el-icon-refresh-left" type="text" size="medium">重置密码</el-button>
                    <el-button @click="deleteAccount(scope.row.id)" type="text" icon="el-icon-delete" size="medium">删除</el-button>
                  </div>
                  <!-- <div class="line">|</div>
                  <div @click="assignRoles(scope.row.id)">分配角色</div>
                  <div class="line">|</div>
                  <div @click="edit(scope.row.id)">编辑</div>
                  <div class="line">|</div>
                  <div @click="resetPassword(scope.row.id)">重置密码</div>
                  <div class="line">|</div>
                  <div @click="deleteAccount(scope.row.id)">删除</div> -->
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="15"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
    <!-- 添加编辑框 -->
    <el-dialog
      class="system-dialog"
      :show-close="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="44%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="accountManageForm"
        :model="accountManageForm"
        :rules="accountManageFormRules"
        label-width="80px"
      >
        <el-form-item label="账号" prop="username">
          <el-input
            v-model="accountManageForm.username"
            placeholder=""
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="accountManageForm.name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="accountManageForm.sex">
            <el-radio label="0">男</el-radio>
            <el-radio label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="职务" prop="position">
          <el-input
            v-model="accountManageForm.position"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="mobile">
          <el-input
            v-model="accountManageForm.mobile"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="accountManageForm.email" placeholder=""></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAccount">保存</el-button>
      </span>
    </el-dialog>

    <!-- 分配角色框 -->
    <el-dialog
      title="分配角色"
      :visible.sync="assignDialogVisible"
      width="44%"
      :close-on-click-modal="false"
    >
      <el-checkbox-group v-model="assignList" @change="selectRole" :max="1">
        <template v-for="(item, index) in rolesList">
          <el-checkbox :label="item.id" :key="index">{{
            item.name
          }}</el-checkbox>
        </template>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAssignRoles">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'

export default {
  data () {
    return {
      // 模糊查询
      // 账号
      account: '',
      tableData: [],
      // 添加编辑模态框
      dialogVisible: false,
      dialogTitle: '添加管理人员',
      isDisabled: false,
      accountManageForm: {
        username: '',
        name: '',
        sex: '',
        position: '',
        email: '',
        mobile: '',
        userType: '1'
      },
      accountManageFormRules: {
        username: { required: true, message: '请填写账号', trigger: 'blur' },
        name: { required: true, message: '请填写姓名', trigger: 'blur' }
      },
      // 分配角色模态框
      assignDialogVisible: false,
      assignList: [],
      rolesList: [],
      accountId: '',
      currentId: '',
      // 角色id
      roleId: '',
      currentPage: 1,
      pageSize: 15,
      total: 0
    }
  },
  components: {
    navHeader
  },
  created () {
    this.getRolistForAssing()
    this.getAccountList()
  },
  methods: {
    // 分配角色获取数据列表
    async getRolistForAssing () {
      let { data: res } = await this.$http.post('/api/role/getRolistForAssing')
      if (res.code === 200) {
        this.rolesList = res.data
      }
    },
    // 获取账号数据
    async getAccountList () {
      let params = {
        loginName: '',
        name: this.account,
        email: '',
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        userType: 1
      }
      let { data: res } = await this.$http.post(
        '/api/user/getUserList',
        params
      )
      if (res.code === '200') {
        this.total = parseInt(res.data.total)
        this.tableData = res.data.records
      }
    },
    // 新增
    addAccount () {
      this.isDisabled = false
      this.dialogVisible = true
      this.dialogTitle = '新增管理人员'
      this.accountManageForm = {
        username: '',
        name: '',
        sex: '',
        position: '',
        email: '',
        mobile: '',
        userType: '1'
      }
    },
    // 查询
    search () {
      this.getAccountList()
    },
    // 重置
    reset () {
      this.account = ''
      this.getAccountList()
    },
    // 保存管理人员
    async saveAccount () {
      let params = JSON.parse(JSON.stringify(this.accountManageForm))
      let url = ''
      if (this.isDisabled) {
        url = '/api/user/updateSaveUser'
      } else {
        url = '/api/user/addUser'
      }
      let { data: res } = await this.$http.post(url, params)
      if (res.code === '200') {
        this.$message.success(res.msg)
        this.getAccountList()
        this.dialogVisible = false
      } else {
        this.$message.error(res.msg)
      }
    },
    // 是否冻结账号
    async isLock (id, v) {
      let params = {
        id,
        lockFlag: v
      }
      let { data: res } = await this.$http.post(
        '/api/user/modifyAccountStatus',
        params
      )
      if (res.code === '200') return this.$message.success(res.msg)
      this.$message.error(res.msg)
      this.getAccountList()
    },
    // 分配角色弹窗
    async assignRoles (userId) {
      console.log(userId)
      this.accountId = userId
      this.assignList = []
      let params = {
        userId
      }
      let { data: res } = await this.$http.post(
        '/api/role/getRoleIdByUserId',
        params
      )
      if (res.code === '200') {
        if (res.data) {
          this.roleId = res.data.roleId
          this.rolesList.forEach((item) => {
            if (item.id === res.data.roleId) {
              this.assignList.push(item.id)
              this.currentId = item.id
            }
          })
        }
      }
      this.assignDialogVisible = true
    },
    // 选择数据
    selectRole (data) {
      console.log(data)
      this.currentId = data[0]
    },
    // 保存分配角色
    async saveAssignRoles () {
      let _this = this
      // 获取参数
      let params = {
        userId: _this.accountId,
        roleId: _this.currentId
      }
      let { data: res } = await _this.$http.post(
        '/api/role/assingRole',
        params
      )
      if (res.code === '200') {
        _this.$message({
          message: res.msg,
          type: 'success'
        })
        _this.assignDialogVisible = false
      } else {
        _this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 编辑
    async edit (userId) {
      this.isDisabled = true
      this.dialogTitle = '编辑管理人员'
      let params = {
        id: userId
      }
      let { data: res } = await this.$http.post(
        '/api/user/getUserById',
        params
      )
      if (res.code === '200') {
        this.accountManageForm = res.data
      }
      this.dialogVisible = true
    },
    // 重置密码
    async resetPassword (id) {
      let _this = this
      _this
        .$confirm('确定重置该账号的密码吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(async () => {
          let { data: res } = await this.$http.post('/api/user/resetPassword', {
            id
          })
          if (res.code === '200') {
            _this.$message.success(res.msg)
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 删除
    deleteAccount (id) {
      let _this = this
      _this
        .$confirm('确定删除该账号吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(async () => {
          let params = {
            id: id
          }
          let { data: res } = await _this.$http.post(
            '/api/user/deleteUserById',
            params
          )
          if (res.code === '200') {
            _this.$message.success(res.msg)
            _this.getAccountList()
          } else {
            _this.$message.error(res.msg)
          }
        })
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getAccountList()
    }
  }
}
</script>
<style lang="less">
.account-manage {
}
</style>



// WEBPACK FOOTER //
// src/pages/systemManagement/users.vue